import React, {FC} from 'react';
import {useTranslation as useTranslationBase} from '@aboutyou/i18n';

export const useTranslation = useTranslationBase;

/**
 * @deprecated Only implemented for legacy stacks. Better use `useTranslation` directly
 */
export const translate = () => {
  return <T extends object>(InnerComponent: React.ComponentType<T>) => {
    const WrappedComponent: React.FC<T> = props => {
      const {t} = useTranslation();
      return <InnerComponent t={t} {...props} />;
    };
    return WrappedComponent;
  };
};

/**
 * @deprecated Only implemented for legacy stacks.
 */
// @ts-ignore
export const Translation: FC<{children: ({t: any}) => any}> = ({children}) => {
  const {t} = useTranslation();

  return children({t});
};
